import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from "recharts";

type ChartData = {
  name: string;
  value: number;
};

interface PieChartComponentProps {
  title: string;
  data: ChartData[];
  colordata: string[]; // Array of color hex codes (without `#`)
  hireConversionRate?: number
}

// Custom label inside each slice
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  value,
}: any) => {
  const RADIAN = Math.PI / 180;
  const radius = outerRadius * 0.7;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x + 1}
      y={y + 1}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={13}
      fontWeight={700}
    >
      {value}
    </text>
  );
};

// ✅ Custom Tooltip Component
const CustomTooltip = ({
  active,
  payload,
  colordata,
  data,
}: {
  active?: boolean;
  payload?: any;
  colordata: string[];
  data: ChartData[];
}) => {
  if (active && payload && payload.length) {
    const { name, value } = payload[0].payload;
    const index = data.findIndex(item => item.name === name);
    const bgColor = `#${colordata[index % colordata.length]}`;

    return (
      <div
        className="rounded px-3 py-1 text-sm text-white font-medium shadow"
        style={{
          backgroundColor: bgColor,
          border: `1px solid ${bgColor}`,
        }}
      >
        {name}: {value}
      </div>
    );
  }
  return null;
};

export default function PieCharts({
  title,
  data,
  colordata,
  hireConversionRate
}: PieChartComponentProps) {
  const isSingleData = data.length === 1;

  return (
    <div>
      {/* Chart Title */}
      <h2 className="text-sm font-semibold text-gray-600 mb-4">{title}</h2>

      {/* Chart Container */}
      <div className="bg-white pt-8 px-4 pb-4 rounded-xl shadow w-full">
        {hireConversionRate >= 0 && <div className="flex justify-end">
          <h1 className="text-sm font-semibold text-gray-600">Hire Conversion Rate: {hireConversionRate.toFixed(2)}%</h1>
        </div>}
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              labelLine={false}
              label={renderCustomizedLabel}
              paddingAngle={isSingleData ? 0 : 4}
            >
              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={`#${colordata[index % colordata.length]}`}
                />
              ))}
            </Pie>

            {/* ✅ Custom Tooltip with matching color */}
            {/* <Tooltip
              content={<CustomTooltip colordata={colordata} data={data} />}
            /> */}

            {/* Legend Below Chart */}
            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
              iconSize={10}
              wrapperStyle={{
                marginTop: 20,
                paddingTop: 10,
                fontSize: "13px",
                color: "#555",
                fontWeight: 500,
                lineHeight: "20px",
                textAlign: "center",
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
